module.exports = __webpack_public_path__ + "static/img/bobcat-logo.3e5590b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clientlogos/bobcat-logo.jpg
// module id = CX7l
// module chunks = 1